import { BusinessRegistrationService } from '../../../_services';
import {
  brRuntimeState,
  loadBrSubmissionStatus,
} from '../../../constants/businessRegistration';
import { unwrapBrApiRows } from '../../../constants/brList';
import { getItemStatusCode, isBrPendingCode } from './brDocument';
import { isBrNameChangeRequestKind } from '../../../constants/brRequestKind';

const SUPPLIER_LOAD_ERROR_CODES = new Set(['SUMMARY', 'LIST', 'PARTIAL', 'NAME_CHANGE']);

/** 从 AdminPending / 列表 API 响应中取出待审更名行 */
export function extractPendingNameChangeRows(apiResOrData) {
  const data = apiResOrData && typeof apiResOrData === 'object' && 'data' in apiResOrData
    ? apiResOrData.data
    : apiResOrData;
  return unwrapBrApiRows(data).filter(
    (row) => isBrNameChangeRequestKind(row) && isBrPendingCode(getItemStatusCode(row)),
  );
}

/**
 * 提交前强制刷新列表做同号校验（供应商 runtime / 管理端双源）。
 * @returns {Promise<{ ok: boolean, list: Array, nameChanges: Array }>}
 */
export async function refreshBrListsForDuplicateCheck({
  fromAdmin = false,
  empCompanyId = 0,
} = {}) {
  if (!fromAdmin) {
    await loadBrSubmissionStatus('hard');
    const err = brRuntimeState.lastLoadError;
    if (SUPPLIER_LOAD_ERROR_CODES.has(err)) {
      return { ok: false, list: [], nameChanges: [] };
    }
    return {
      ok: true,
      list: brRuntimeState.documentList || [],
      nameChanges: brRuntimeState.nameChangePending || [],
    };
  }

  const companyId = Number(empCompanyId);
  if (!Number.isFinite(companyId) || companyId <= 0) {
    return { ok: false, list: [], nameChanges: [] };
  }

  try {
    const [listRes, pendingRes] = await Promise.all([
      BusinessRegistrationService.GetList({ empCompanyId: companyId }),
      BusinessRegistrationService.GetAdminPending(companyId),
    ]);
    if (!listRes?.isSuccessful || !pendingRes?.isSuccessful) {
      return { ok: false, list: [], nameChanges: [] };
    }
    return {
      ok: true,
      list: unwrapBrApiRows(listRes?.data),
      nameChanges: extractPendingNameChangeRows(pendingRes),
    };
  } catch (e) {
    return { ok: false, list: [], nameChanges: [] };
  }
}
